import Vue from 'vue'
import store from '@/store'
import routes from './routes'
import VueMeta from 'vue-meta'
import VueRouter from 'vue-router'
import middlewarePipeline from './middlewarePipeline'

Vue.use(VueRouter)
Vue.use(VueMeta)

Vue.router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'active',
    scrollBehavior: () => ({ y: 0 }),
    routes: routes,
})

const beforeEachAction = (to, from, next) => {
    // reset filters after each route changing
    store.dispatch('filterMeComponent/reset')
    store.dispatch('messageComponent/resetMsg')
    store.dispatch('loadingComponent/hideShowLoading')
    store.dispatch('filterMeComponent/hideCollapse')

    if (!to.meta.middleware || to.meta.middleware.length === 0) {
        return next()
    }

    const middleware = to.meta.middleware

    const context = {
        to,
        from,
        next,
        store,
        nextVue: next,
    }

    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    })
}

Vue.router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && store.getters['oauth2/isTokenExpired']()) {
        store.dispatch('oauth2/login')
        return
    }

    // redirect old login and register to accounts
    if (to.fullPath === '/auth/login' || to.fullPath === '/auth/register') {
       window.location = process.env.VUE_APP_BASE_OAUTH2+'/login'
       return
    }

    // check if current user is null, fecth it
    if(to.name !== 'callback' && !store.getters['user/is_current_fetched']) {
        await store.dispatch('user/fetchCurrent').then(() => {
            beforeEachAction(to, from, next)
        })
    } else {
        beforeEachAction(to, from, next)
    }
})

export default Vue.router
